export const filterHighRailway = (list) => {
    let reg = /^G/;
    let arr = [];
    list.forEach(element => {
        if(reg.test(element.trainNo)){
            arr.push(element)
        }
    });
    return arr;
}

export const filterHasRailway = (list) => {
    let arr = [];
    list.forEach((element,index) => {
        for(var i = 0;i<= element.tickets.length;i++){
            if(element.tickets[i]){
                if(element.tickets[i].seatNumber > 0){
                    arr.push(element)
                    return;
                }
            }
            
        }
    });
    return arr;
}

export const filterCompreRailway = (list,params,allTag,sortTag) => {
    let arr = [];

    //条件过滤
    if(!params.trainClasses.length && !params.stations.length && !params.seatNames.length ){
        arr = list
    }else{
        list.forEach((element,index) => {
            //7种筛选状况
            //123
            if(params.trainClasses.length && params.stations.length && params.seatNames.length){
                if(trainClasses(element,params) && stations(element,params) && seatNames(element,params)){
                    arr.push(element)
                }
            }
            //12
            else if(params.trainClasses.length && params.stations.length ){
                if(trainClasses(element,params) && stations(element,params) ){
                    arr.push(element)
                }
            }
            //13
            else if(params.trainClasses.length && params.seatNames.length ){
                if(trainClasses(element,params) && seatNames(element,params) ){
                    arr.push(element)
                }
            }
            //23
            else if(params.stations.length && params.seatNames.length ){
                if(stations(element,params) && seatNames(element,params) ){
                    arr.push(element)
                }
            }
            //单一
            else if(params.stations.length){
                if(stations(element,params) ){
                    arr.push(element)
                }
            }
            else if(params.seatNames.length){
                if(seatNames(element,params) ){
                    arr.push(element)
                }
            }
            else if(params.trainClasses.length){
                
                if(trainClasses(element,params) ){
                    arr.push(element)
                }
            }
    
        });
    }
    //是否有票筛选过滤
    if(allTag){
        arr = filterHasRailway(arr)
    }

    //是否进行排序
    if(sortTag){
        // 1出发时间正续  接口默认
        // 2出发时间倒序    
        // 3运行时长正序  
        // 4运行时长倒序  
        // 5到达时间正序  
        // 6到达时间倒序  
        if(sortTag == 1){
            arr = sorFromTime(arr)
        }
        if(sortTag == 2){
            arr = sorFromTimeDesc(arr)
        }
        if(sortTag == 3){
            arr = sorTakeTime(arr)
        }
        if(sortTag == 4){
            arr = sorTakeTimeDesc(arr)
        }
    }


    return arr;
}

function sorTakeTime(list){    
    let arr2 = [...list]
    arr2.sort(function(a,b){
        if(a.takeTime > b.takeTime){
            return 1
        }else{
            return -1
        }
    })
    return arr2
}

function sorTakeTimeDesc(list){    
    let arr2 = [...list]
    arr2.sort(function(a,b){
        if(a.takeTime < b.takeTime){
            return 1
        }else{
            return -1
        }
    })
    return arr2
}


function sorFromTime(list){    
    return list
}
function sorFromTimeDesc(list){
    let arr2 = [...list].reverse()
    return arr2
}

function trainClasses(element,params){

    if(params.trainClasses.indexOf(element.trainClass) > -1){
        return true
    }else{
        return false;
    }
}

function stations(element,params){
    if(params.stations.indexOf(element.fromStation) > -1 || params.stations.indexOf(element.toStation) > -1){
        return true
    }else{
        return false;
    }
}

function seatNames(element,params){
    for(var i = 0;i<= element.tickets.length;i++){
        if(element.tickets[i]){
            if(params.seatNames.indexOf(element.tickets[i].seatName) > -1){
                return true    
            }
        }
    }
    return false;
}
